import { render, staticRenderFns } from "./dizhi.vue?vue&type=template&id=232d8f0e&scoped=true&"
import script from "./dizhi.vue?vue&type=script&lang=js&"
export * from "./dizhi.vue?vue&type=script&lang=js&"
import style0 from "./dizhi.vue?vue&type=style&index=0&id=232d8f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232d8f0e",
  null
  
)

export default component.exports